// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bfu_a bht_wj bht_ss bht_xl"};